// extracted by mini-css-extract-plugin
export var InstagramGallery = "InstagramGallery-module--InstagramGallery--1ma9D";
export var InstagramGallery__post = "InstagramGallery-module--InstagramGallery__post--1LEjA";
export var InstagramGallery__post_caption = "InstagramGallery-module--InstagramGallery__post_caption--3NC8b";